import { EmberRoute } from '../../../../../../../enums/emberRoute'
import { withAnalyticsTracking } from '../../../utils/withAnalyticsTracking'
import { StaticActionHandler } from '../actionHandlers'
import { TransactionsInvoicesActionType } from '../utils/getInvoicesActions'

export const invoiceActionHandlers: Record<TransactionsInvoicesActionType, StaticActionHandler> = {
  [TransactionsInvoicesActionType.Credit]: withAnalyticsTracking(
    ({ originatorId, generateUrl, transitionTo }) => {
      if (generateUrl) {
        transitionTo(generateUrl(EmberRoute.InvoiceCreditNote, originatorId))
      }
    },
    'Invoices',
    TransactionsInvoicesActionType.Credit,
  ),

  [TransactionsInvoicesActionType.Duplicate]: withAnalyticsTracking(
    ({ originatorId, generateUrl, transitionTo }) => {
      if (generateUrl) {
        transitionTo(`${generateUrl(EmberRoute.InvoicesNew)}?from_invoice_id=${originatorId}`)
      }
    },
    'Invoices',
    TransactionsInvoicesActionType.Duplicate,
  ),

  [TransactionsInvoicesActionType.RegisterPayment]: withAnalyticsTracking(
    ({ registerPaymentForInvoice, originatorId }) => {
      registerPaymentForInvoice({ id: originatorId })
    },
    'Invoices',
    TransactionsInvoicesActionType.RegisterPayment,
  ),

  [TransactionsInvoicesActionType.Void]: withAnalyticsTracking(
    ({ handleVoidInvoice }) => {
      handleVoidInvoice()
    },
    'Invoices',
    TransactionsInvoicesActionType.Void,
  ),
}
